import { render, staticRenderFns } from "./CompanyHeader.vue?vue&type=template&id=e9b04c76&scoped=true"
import script from "./CompanyHeader.vue?vue&type=script&lang=js"
export * from "./CompanyHeader.vue?vue&type=script&lang=js"
import style0 from "./CompanyHeader.vue?vue&type=style&index=0&id=e9b04c76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b04c76",
  null
  
)

export default component.exports